
export enum DetailType {
    Invoice = 'invoice',
    Advance = 'advance',
}

export enum DocType {
    Invoice = 'Invoice',
    RateConfirmation = 'Rate Confirmation',
    BillOfLading = 'Bill of Lading / Delivery Receipt',
    Lumper = 'Lumper Receipt',
    PalletReceipt = 'Pallet Receipt / Scale or Gate Ticket',
    CarrierDoc = 'Other Internal Documents',
    Other = 'Additional Backup',
}

export interface DetailDocument {
    documentId: string;
    filename: string;
    docType: DocType;
    uploadedDate: string;
    url: string;
}
export interface DocumentsCardProps {
    assetId: number;
    detailType: DetailType;
}
